import React from "react";
import { Button } from "../../../../../shadcn/components/ui/button";
interface SwitchToOtherKYCModeNotificationProps {
  handleSwitch: (id: any) => Promise<void>;
  switchingToModes: boolean;
  switchMode: "Online" | "Offline";
}

export default function SwitchToOtherKYCModeNotification({
  handleSwitch,
  switchingToModes,
  switchMode,
}: SwitchToOtherKYCModeNotificationProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 px-4 py-2 my-2 bg-blue-50 border-l-4 border-blue-500 rounded-sm mt-4">
      <div className="flex items-start sm:items-center space-x-3 flex-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5 sm:mt-0"
        >
          <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          />
        </svg>
        {switchMode === "Online" && (
          <div className="flex-1">
            <p className="text-blue-800 text-sm font-medium">
              Switch to Online KYC mode?
            </p>
            <p className="text-blue-700 text-xs mt-1">
              You can switch to Online KYC mode. This will allow you to complete
              your KYC instantly using our integrated online verification
              process. No physical submissions required!
            </p>
          </div>
        )}
        {switchMode === "Offline" && (
          <div className="flex-1">
            <p className="text-blue-800 text-sm font-medium">
              Facing issues with Online KYC?
            </p>
            <p className="text-blue-700 text-xs mt-1">
              You can switch to Offline KYC mode by uploading your documents
              manually. Once done, fill out the auction participation form and
              submit it to the bank to complete your participation.
            </p>
          </div>
        )}
      </div>
      <Button
        onClick={async () => await handleSwitch(switchMode)}
        disabled={switchingToModes}
        variant="outline"
        className="border-brand-headingBlue text-brand-headingBlue text-xs"
      >
        {switchingToModes ? "Switching..." : `Switch to ${switchMode} Mode`}
      </Button>
    </div>
  );
}
